import { StyleRules, InputLabelClassKey } from '@material-ui/core';
import colors from '../colors.module.scss';

export const MuiInputLabel: Partial<StyleRules<InputLabelClassKey, {}>> = {
  asterisk: {
    fontWeight: 'bold',
    color: colors.black,
  },
};
